import React from 'react';

import { cn } from '@/lib/utils';

const statusMap = {
  online: 'bg-emerald-500/20 text-emerald-400 [&>span]:bg-emerald-400',
  offline: 'bg-rose-500/20 text-rose-400 [&>span]:bg-rose-400',
  idle: 'bg-amber-500/20 text-amber-400 [&>span]:bg-amber-400',
  open: 'bg-blue-500/20 text-blue-400 [&>span]:bg-blue-400',
  resolved: 'bg-emerald-500/20 text-emerald-400 [&>span]:bg-emerald-400',
  acknowledged: 'bg-amber-500/20 text-amber-400 [&>span]:bg-amber-400',
  ack: 'bg-amber-500/20 text-amber-400 [&>span]:bg-amber-400',
};

export default function StatusBadge({ status = 'idle' }) {
  const normalized = String(status).toLowerCase();
  const label = normalized === 'ack' ? 'acknowledged' : normalized;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-medium capitalize',
        statusMap[normalized] || statusMap.idle
      )}
    >
      <span className="h-2 w-2 rounded-full" />
      {label}
    </span>
  );
}
